import i18n from '@/utils/i18n';
import { AnalyticsAlertType } from '@/types';
import { createStyles } from '@/contexts/theme-context';
import { FONTS, TYPOGRAPHY } from '@/styles';
import { Text, View } from 'react-native';
import { useMemo } from 'react';

interface Pill {
  alertType: AnalyticsAlertType;
}

export const AccountStatusPill: React.FC<Pill> = ({ alertType }) => {
  const [styles, theme] = useStyles();

  const { backgroundColor, text } = useMemo(() => {
    switch (alertType) {
      case AnalyticsAlertType.ChurnRisk:
        return {
          backgroundColor: theme.colors.alertNegative,
          text: i18n.t('dsr_analytics.alerts.churn_risk'),
        };
      case AnalyticsAlertType.LostItem:
        return {
          backgroundColor: theme.colors.alertNegative,
          text: i18n.t('dsr_analytics.alerts.lost_item'),
        };
      case AnalyticsAlertType.OverduePayment:
        return {
          backgroundColor: theme.colors.alertNegative,
          text: i18n.t('dsr_analytics.alerts.overdue_payment'),
        };

      default:
        return { backgroundColor: '', text: null };
    }
  }, [alertType, theme]);

  return (
    <View style={[styles.pill, { backgroundColor }]}>
      <Text style={[TYPOGRAPHY.listSmall, FONTS.primarySemiBold]}>{text}</Text>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  pill: {
    alignSelf: 'flex-start',
    borderColor: theme.colors.primary,
    borderRadius: 4,
    paddingHorizontal: 8,
    paddingVertical: 4,
  },
}));
